import React, { createContext, useContext } from 'react';

/**
 * AppContext — expose les valeurs globales partagées entre composants
 * pour éviter le prop drilling depuis App.js.
 *
 * Ce contexte est un simple transport layer : App.js détient l'état
 * (useState/useEffect) et passe les valeurs via <AppProvider value={...}>.
 *
 * Données exposées :
 *  - currentUser, isAdmin, isComptable, hasWriteAccess (rôles / sécurité)
 *  - settings (paramètres entreprise + devise)
 *  - apiCall, showNotification (helpers réseau / UX)
 *  - getPaginatedItems, itemsPerPage, setItemsPerPage (pagination commune)
 *  - clients, produits (référentiels souvent partagés)
 */
const AppContext = createContext(null);

export const AppProvider = ({ value, children }) => (
  <AppContext.Provider value={value}>{children}</AppContext.Provider>
);

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) {
    throw new Error("useApp doit être utilisé à l'intérieur d'un AppProvider");
  }
  return ctx;
};

export default AppContext;
